import { render, staticRenderFns } from "./DownloadSetting.vue?vue&type=template&id=0dd4f640&scoped=true&"
import script from "./DownloadSetting.vue?vue&type=script&lang=ts&"
export * from "./DownloadSetting.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadSetting.vue?vue&type=style&index=0&id=0dd4f640&prod&lang=scss&scoped=true&"
import style1 from "./DownloadSetting.vue?vue&type=style&index=1&id=0dd4f640&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd4f640",
  null
  
)

export default component.exports